import React from 'react';
import styles from './EmptyState.module.scss';
import {Text} from '@gravity-ui/uikit';
import {ReactComponent as DefaultIcon} from '../../assets/icons/empty-search-icon.svg';

interface EmptyStateProps {
  title: string;
  description: string;
  icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
}

export const EmptyState = ({title, description, icon: Icon = DefaultIcon}: EmptyStateProps) => {
  return (
    <div className={styles.emptyStateContainer}>
      <div className={styles.iconContainer}>
        <Icon className={styles.icon} />
      </div>
      <div className={styles.textContainer}>
        <Text variant="subheader-2">{title}</Text>
        <Text variant="body-1" color={'secondary'}>
          {description}
        </Text>
      </div>
    </div>
  );
};
